import React from 'react'
import IndustrySector from '../industryComponents/IndustrySector'
import IndustryDesign from '../industryComponents/IndustryDesign'
import HomeTab from '../../home/HomeTab'
import HomeResource from '../../home/HomeResource'
import SustainabilityBanner from '../../sustainability/SustainabilityBanner'
import DynamicBreadcrumb from '../../../components/DynamicBreadcrumb'
import IndustryInvest from '../industryComponents/IndustryInvest'
import IndustryServe from '../industryComponents/IndustryServe'

const breadcrumbData = [
  {
    slug: "/",
    page: "Home",
  },
  {
    slug: "",
    page: "Industries",
  },
  {
    slug: "",
    page: "Media & Entertainment",
  },
];

const bannerData = {
  img:"assets/images/media-industry-banner.webp",
  leftHead:"Media & Entertainment",
  rightHead:"Bringing Structure to High-Volume Content Operations",
  desc:"In the media and entertainment industry, speed, organization, instant access to content are critical. Dox and Box enables organizations to manage large volumes of digital assets with precision, ensuring secure storage, streamlined workflows, quick retrieval to keep production moving without delays."
}

const sectorData ={
  head:"Sector Overview",
  overview:"Media and entertainment companies operate in a fast-paced, content-driven environment where efficiency and accessibility are key. From raw footage and creative assets to contracts and distribution files, managing vast amounts of data requires structured systems and controlled access. Dox and Box provides secure, scalable, organized document and digital asset management solutions that enhance production efficiency, improve collaboration, ensure complete control over content."
}

const designData = {
  head:"Tailored Solutions for Media & Entertainment",
  img:"/assets/images/media-industry-designn.webp",
  desc:[
    "We deliver flexible and scalable solutions designed to support the dynamic needs of media organizations. Our systems are built to simplify content management while ensuring security, accessibility, operational efficiency.",
    "With a deep understanding of media workflows, we help organizations reduce manual effort, streamline operations, manage content more effectively across teams and locations",
  ],
  list:[
    "Organized storage for multimedia assets and business documents",
    "Permission-driven access to strengthen content protection",
    "Instant and reliable content search and retrieval",
    "Compliance-focused rights and content management",
    "Automated workflows to accelerate production processes",
    "Flexible systems designed for expanding media collections",
  ]
}


const tabData = [
  {
    icon: "/assets/images/home-tab-icon-1.webp",
    title: "Physical Records & Archive Management",
    heading:"Secure, Structured, Scalable Physical Record Storage",
    desc:"Managing physical documents doesn’t have to mean cluttered offices or lost files. At Dox and Box, we offer end-to-end physical records management designed to keep your documents secure, accessible, fully compliant. Our state-of-the-art archival facilities are built with strict security protocols, environmental controls, fire safety systems.",
    slug:"/physical-records-management-services",
    image:"/assets/images/home-tab-image-1.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-2.webp",
    title: "Scanning & Digitization Services",
    heading:"Transform Paper Documents into Searchable Digital Assets",
    desc:"Move beyond manual paperwork with high-precision scanning and digitization services. We convert your physical records into structured, searchable, easily accessible digital formats. Using advanced scanning technology and intelligent indexing, we ensure every document is accurately captured and categorized.",
    slug:"/digitization-services",
    image:"/assets/images/home-tab-image-2.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-3.webp",
    title: "Intelligent Document Processing & AI-driven Extraction",
    heading:"Unlock Data from Documents with AI-Powered Intelligence",
    desc:"Turn unstructured documents into actionable data with our AI-driven document processing solutions. We leverage advanced technologies like machine learning, OCR, natural language processing to extract, classify, validate information automatically. From invoices and contracts to forms and reports, our system reduces manual effort, minimizes errors, accelerates workflows. ",
    slug:"/ai-document-data-extraction",
    image:"/assets/images/home-tab-image-3.webp"
  },
  {
    icon: "/assets/images/home-tab-icon-4.webp",
    title: "Data Governance & Compliance Platform (SaaS)",
    heading:"Ensure Compliance, Control, Visibility Across Your Data",
    desc:"In today’s regulatory landscape, managing data securely and compliantly is critical. Our SaaS-based data governance platform provides centralized control over your documents, ensuring they are stored, accessed, managed in line with industry regulations. With role-based access, audit trails, retention policy automation, businesses gain complete visibility and control over their data.",
    slug:"/data-privacy-governance-compliance-platform",
    image:"/assets/images/home-tab-image-4.webp"
  },
]

const investData = {
  head:"Why Invest in Intelligent Content & Asset Management Solutions?",
  boxes:[
    {
      img:'/assets/images/media-industry-invest-1.webp',
      icon:"/assets/images/media-industry-invest-icon-1.webp",
      title:"Centralized Content Control",
      desc:"Manage all media assets in one structured system.",
    },
    {
      img:'/assets/images/media-industry-invest-2.webp',
      icon:"/assets/images/media-industry-invest-icon-2.webp",
      title:"Fast Asset Retrieval",
      desc:"Access content files instantly when required across all platforms.",
    },
    {
      img:'/assets/images/media-industry-invest-3.webp',
      icon:"/assets/images/media-industry-invest-icon-3.webp",
      title:"Reduced Manual Effort",
      desc:"Reduce manual intervention by automating repetitive content management tasks.",
    },
    {
      img:'/assets/images/media-industry-invest-4.webp',
      icon:"/assets/images/media-industry-invest-icon-4.webp",
      title:"Rights & Usage Management",
      desc:"Track, control, manage content rights and usage permissions efficiently.",
    },
    {
      img:'/assets/images/media-industry-invest-5.webp',
      icon:"/assets/images/media-industry-invest-icon-5.webp",
      title:"Streamlined Workflow",
      desc:"Smooth and efficient content processes across teams and production workflows.",
    },
    {
      img:'/assets/images/media-industry-invest-6.webp',
      icon:"/assets/images/media-industry-invest-icon-6.webp",
      title:"Scalable Asset Storage",
      desc:"Expand storage as media content grows with flexible and scalable infrastructure.",
    },
  ]
}

const serveData = {
  head:"Other Industries We Serve",
  boxes:[
    {
      img:"/assets/images/media-industry-serve-1.webp",
      title:"Financial Services",
      desc:"Financial services demand precision, security, seamless access to critical documents.",
      btnText:"Know More",
      slug:"/financial-institutions"
    },
    {
      img:"/assets/images/media-industry-serve-2.webp",
      title:"Healthcare",
      desc:"Healthcare services require precision, security, seamless access to critical records.",
      btnText:"Know More",
      slug:"/healthcare"
    },
  ]
}

export default function MediaService() {
  return (
    <>
      <DynamicBreadcrumb breadcrumbData={breadcrumbData} />
      <SustainabilityBanner data={bannerData} />
      <IndustrySector data={sectorData} />
      <IndustryDesign data = {designData}/>
      <HomeTab tabData={tabData}/>
      <HomeResource/>
      <IndustryInvest data = {investData}/>
      <IndustryServe data={serveData}/>
    </>
  )
}
